var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","dark":""}},[_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }